import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppLayout from './layouts/AppLayout';
import DashboardLayout from './layouts/DashboardLayout';
import Home from './pages/Home';
import FAQ from './pages/FAQ';
import NotFound from './pages/NotFound';
import "react-photo-view/dist/react-photo-view.css";
import Statistics from './components/dashboard/Statistics';
import Products from './pages/Products';
import ProductNew from './pages/ProductNew';
import ProductEdit from './pages/ProductEdit';
import ProductDetail from './pages/ProductDetail';
import ProductStockAdd from './pages/ProductStockAdd';
import Orders from './pages/Orders';
import OrderNew from './pages/OrderNew';
import OrderDetail from './pages/OrderDetail';
import Customers from './pages/Customers';
import CustomerNew from './pages/CustomerNew';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Home />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="dashboard" element={<DashboardLayout />}>
            <Route index element={<Statistics />} />
              <Route path="products">
              <Route index element={<Products />} />
              <Route path="new" element={<ProductNew />} />
              <Route path=":id" element={<ProductDetail />} />
              <Route path=":id/edit" element={<ProductEdit />} />
              <Route path=":id/stock" element={<ProductStockAdd />} />
            </Route>
            <Route path="orders">
              <Route index element={<Orders />} />
              <Route path="new" element={<OrderNew />} />
              <Route path=":id" element={<OrderDetail />} />
            </Route>
            <Route path="customers">
              <Route index element={<Customers />} />
              <Route path="new" element={<CustomerNew />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
